import React from 'react';
import { Box, Link, Stack, Typography } from '@mui/material';
import error from 'dashboard/assets/img/others/error.png';

export default function UnAuthorized() {
  return (
    <Stack direction='column' alignItems='center' sx={{ pt: { xs: '125px', lg: '75px' } }}>
      <Box
        component='img'
        src={error}
        alt=''
        sx={{ width: '400px', maxWidth: '90%', mt: { xs: '4vh', lg: '20vh' }, mb: '10px' }}
      />
      <Typography
        fontWeight='700'
        textAlign={{ xs: 'center', md: 'start' }}
        sx={{ fontSize: { xs: '40px', lg: '46px' }, mb: '30px' }}
      >
        Sorry you don't have access to this page
      </Typography>
      <Stack direction={{ xs: 'column', md: 'row' }} alignItems='center'>
        <Typography fontWeight='500' sx={{ fontSize: { xs: 'md', md: 'lg' }, mr: '4px' }}>
          Maybe it's best you start back at our home page…
        </Typography>
        <Link href='/' color='primary' underline='hover' fontWeight='500'>
          Return at home here.
        </Link>
      </Stack>
    </Stack>
  );
}
